import './Hero.css';
import { useTranslation } from '../i18n/LanguageContext.jsx';

function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <img
            className="hero-logo"
            src="/assets/logo-icon.webp"
            alt={t('hero.logoAlt')}
            width="300"
            height="300"
            fetchPriority="high"
          />
          <h1 className="hero-title" aria-label={t('hero.title')}>
            <span className="hero-title-explain">explain</span>
            <span className="hero-title-it">IT</span>
          </h1>
          <p className="hero-subtitle">{t('hero.subtitle')}</p>
          <p className="hero-description">{t('hero.description')}</p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
